<template>
  <div v-if="imageUrls?.mobile && imageUrls?.desktop" class="block-hero-landingpage">
    <div class="block-hero-landingpage__image">
      <picture class="block-hero-landingpage__picture">
        <source
          media="(max-width:7678px)"
          :srcset="imageUrls.mobile"
        >
        <img
          :src="imageUrls.desktop"
          :alt="image.alt"
        >
      </picture>

      <AtomImageLabel
        v-if="isArrayNotEmpty(label)"
        :data="label[0]"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    image: {
        type: Object,
        default: () => {},
    },

    label: {
        type: Array,
        default: () => [],
    },
});

const imageUrls = computed(() => {
    if (!props?.image?.filename) return null;
    console.log(props.image);

    return {
        mobile: `${props.image.filename}/m/768x639/${props.image.focus ? `filters:focal(${props.image.focus})` : ''}`,
        desktop: `${props.image.filename}/m/1920x867/${props.image.focus ? `filters:focal(${props.image.focus})` : ''}`,
    };
});

</script>

<style lang="scss" scoped>
.block-hero-landingpage {
    @include fluid('margin-bottom', 30px, 50px);
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    border-bottom-right-radius: 280px;

    @include mobile {
        padding-top: 140px;
        background: $C_GREEN_BRIGHT;
        border-bottom-right-radius: 80px;

    }
}

.block-hero-landingpage__image {
    position: relative;
    overflow: hidden;
    width: 100%;
    max-height: 690px;
    aspect-ratio: 144 / 65;

    @include mobile {
        aspect-ratio: 6 / 5;
        border-top-left-radius: 60px;
    }

    &.is-mobile {
        display: none;

        @include mobile {
            display: block;
        }
    }

    &.is-desktop {
        display: block;

        @include mobile {
            display: none;
        }
    }
}

.block-hero-landingpage__picture {
    position: relative;
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;

    img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.block-hero-landingpage__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 690px;
    aspect-ratio: 144 / 65;

    @include mobile {
        max-height: unset;
        aspect-ratio: 6 / 5;
    }
}
</style>
